export default (text: string | undefined, maxsize: number) => {
  if (!text || text.length <= maxsize) {
    return text;
  }

  return text.substring(0, maxsize) + '...';
};
